import { useMutation, useQuery } from "react-query";
import { useSelector } from "react-redux";
import { customAPI } from "../services/api";
import { useEffect, useMemo, useState } from "react";
import moment from "moment";
const size = 1000000;
const createComment = (data, token, invoiceId) => {
    return customAPI(token).post(`api/Reports/Invoices/${invoiceId}/Comments`, data, {
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        }
    });
};
const getComments = (token, id, invoiceId, page, filter, sort) =>
    customAPI(token)
        .get(`api/Reports/${id}/Invoices/${invoiceId}/Comments`, { params: { page: 1, size: size } })
        .then((res) => {
            return res?.data?.data
        });

const normalizer = (items) => {
    const newItems = items?.map((item) => ({
        comment: item?.comment,
        createdBy: item?.createdBy,
        date: moment(new Date(item?.createdDate)).format('DD/MM/yyyy')
    }));

    return newItems;
};

const useComments = ({ id, invoiceId, page = 1, filter, sort }) => {
    const [queryVariables, setQueryVariables] = useState({
        invoiceId: invoiceId,
        id: id,
    });
    useEffect(() => {
        setQueryVariables({
            ...{ invoiceId: invoiceId, id: id },
        });
    }, [invoiceId, id]);
    const { token } = useSelector((store) => store.auth);

    const createMutation = useMutation((data) => createComment(data, token, invoiceId), {
        onError: (error) => {
            if (error.response.status == 409) {
                error.message = "Duplicate Comment entry exists";
                return error;
            } else {
                error.message = "Something went wrong";
                return error;
            }
        },
    });
    const { data, isLoading, refetch } = useQuery([
        `GET-COMMENTS`, queryVariables],
        () => getComments(token, id, invoiceId, page, filter, sort)
    );
    const normlizedData = useMemo(() => normalizer(data), [data]);
    return {
        createMutation,
        data: normlizedData, isLoading, refetch
    };
};

export default useComments;
